import React, {useEffect, useState} from 'react';
import {
    Box,
    Container,
    Grid,
    MenuItem,
    Modal, Snackbar,
    Step,
    StepLabel,
    TableBody,
    TableRow,
    TextField,
    Typography,
} from '@mui/material';
import {
    Black, StyledAlert,
    StyledButtonBlack,
    StyledButtonContainer,
    StyledButtonNoColor,
    StyledButtonOrange,
    StyledStepper,
    StyledTable,
    StyledTableCell,
} from '../../styles/MyStyles';
import {useNavigate, useParams} from "react-router-dom";
import {GetEnumValues} from "../../logic/EnumHelper";
import {GetClientViewName} from "../../logic/ClientNameHelper";
import {GetCookieInfo} from "../../logic/CookieManager";
import moment from "moment";
import {GetClient, GetClients} from "../../logic/DataProvider";
import {UpdateTicketStatus} from "../../logic/TicketHelper";
import {DatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import {GetLookupMenuItems, UpdateBanksCache} from "../../logic/LookupHelper";
import {GetBrokerageAgreementTitle} from "../../logic/EntityTitleHelper";
import {GetMessageFilesComponent} from "./TicketFilesHelper";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import ClearIcon from "@mui/icons-material/Clear";

const ManagerTicketPage = () => {

    const [snackbar, setSnackbar] = React.useState({
        open: false,
        vertical: 'top',
        horizontal: 'center',
        message: ''
    });

    const emptyAdditionalMeta = {
        transferDate: '',
        transferFee: '',
        transferFeeAssetId: '',

        limitBrokerageAgreementId: '',
        limitExtensionVolume: '',
        limitTotalVolume: '',
        limitReminderVolume: '',
        limitExtensionNumber: '',
        limitCreatedDate: '',
        limitExtensionDate: ''
    };

    const navigate = useNavigate();

    const { ticketId} = useParams();

    const [errors, setErrors] = useState({});
    const [additionalMetaErrors, setAdditionalMetaErrors] = useState({});

    const [ticket, setTicket] = useState();
    const [clients, setClients] = useState([]);
    const [agreements, setAgreements] = useState([]);

    const [activeStep, setActiveStep] = useState(0);
    const [newMessage, setNewMessage] = useState('');

    const [additionalMeta, setAdditionalMeta] = useState(emptyAdditionalMeta);

    const [showSimpleModal, setShowSimpleModal] = useState(false);
    const [showTransferModal, setShowTransferModal] = useState(false);
    const [showLimitModal, setShowLimitModal] = useState(false);

    const [files, setFiles] = useState(null);
    const [filesToUpload, setFilesToUpload] = useState();


    useEffect(() => {
        GetClients().then((clients) => setClients(clients));
        fetchTicket();
        fetchFiles();
    }, []);

    const fetchTicket = async () => {
        try {
            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_TICKETING_URL}/${ticketId}`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    }
                }
            );
            if (response.ok) {
                const data = await response.json();
                console.log(data.data);

                data.data.messages.sort((a, b) => {
                    const dateA = new Date(a.date);
                    const dateB = new Date(b.date);
                    return dateA - dateB;
                });
                setTicket(data.data);
                setActiveStep(data.data.status);

                if (data.data.subtype === 1) {
                    await fetchAgreements(data.data.authorId);
                }
            } else {
                console.log('Fetch ticket failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const fetchFiles = async () => {
        try {
            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_TICKET_FILES_URL}/${ticketId}`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    }
                }
            );
            if (response.ok) {
                const data = await response.json();
                console.log('fetchFiles');
                console.log(data.data);
                setFiles(data.data);
            } else {
                console.log('Fetch ticket files failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const uploadFile = async (messageId) => {
        try {
            const tokenCookie = GetCookieInfo('nplt');

            const formData = new FormData();

            for (const file of filesToUpload) {
                formData.append('files', file);
            }

            formData.append("ticketId", ticketId);
            formData.append("messageId", messageId);

            const response = await fetch(
                `${process.env.REACT_APP_TICKET_FILES_URL}/upload`,
                {
                    method: 'POST',
                    headers: {
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                    body: formData,
                }
            );
            if (response.ok) {
                console.log('File uploaded successfully.');
                await fetchFiles();

                setFilesToUpload(null);
            } else {
                console.log('File uploading failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const fetchAgreements = async (clientId) => {
        try {
            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_AGREEMENTS_URL}/${clientId}`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                }
            );
            if (response.ok) {
                const data = await response.json();
                console.log(data.data);
                setAgreements(data.data);
            } else {
                console.log('Fetch agreements failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const validateForm = () => {
        let newErrors = {};

        if (!newMessage.trim()) {
            newErrors.newMessage = 'Message is required.';
        }

        return newErrors;
    };

    const validateTransferModal = () => {
        let newErrors = {};

        if (additionalMeta.transferDate === '') {
            newErrors.transferDate = 'Transfer Date is required.';
        }

        if (additionalMeta.transferFee === '') {
            newErrors.transferFee = 'Transfer Fee is required.';
        } else if (isNaN(additionalMeta.transferFee)) {
            newErrors.transferFee = 'Transfer Fee must be number.';
        }

        if (additionalMeta.transferFeeAssetId === '') {
            newErrors.transferFeeAssetId = 'Transfer Fee Asset is required.';
        }

        return newErrors;
    };

    const validateLimitModal = () => {
        let newErrors = {};

        if (additionalMeta.limitBrokerageAgreementId === '') {
            newErrors.limitBrokerageAgreementId = 'Brokerage Agreement is required.';
        }

        if (additionalMeta.limitExtensionVolume === '') {
            newErrors.limitExtensionVolume = 'Extension Volume is required.';
        } else if (isNaN(additionalMeta.limitExtensionVolume)) {
            newErrors.limitExtensionVolume = 'Extension Volume must be number.';
        }

        if (additionalMeta.limitTotalVolume === '') {
            newErrors.limitTotalVolume = 'Total Volume is required.';
        } else if (isNaN(additionalMeta.limitTotalVolume)) {
            newErrors.limitTotalVolume = 'Total Volume must be number.';
        }

        if (additionalMeta.limitReminderVolume === '') {
            newErrors.limitReminderVolume = 'Reminder Volume is required.';
        } else if (isNaN(additionalMeta.limitReminderVolume)) {
            newErrors.limitReminderVolume = 'Reminder Volume must be number.';
        }

        if (additionalMeta.limitExtensionNumber === '') {
            newErrors.limitExtensionNumber = 'Extension Number is required.';
        } else if (isNaN(additionalMeta.limitExtensionNumber)) {
            newErrors.limitExtensionNumber = 'Extension Number must be number.';
        }

        if (additionalMeta.limitCreatedDate === '') {
            newErrors.limitCreatedDate = 'Created Date is required.';
        }

        if (additionalMeta.limitExtensionDate === '') {
            newErrors.limitExtensionDate = 'Extension Date is required.';
        }

        return newErrors;
    };

    const handleBack = () => {
        navigate(-1);
    };

    const saveFile = (e) => {
        if (e.target.files.length > 0) {
            setFilesToUpload(e.target.files);
        } else {
            clearFiles();
        }
    };

    const clearFiles = () => {
        setFilesToUpload(null);
    };

    const handleSendRequest = async () => {
        try {
            const newErrors = validateForm();

            if (Object.keys(newErrors).length > 0) {
                setErrors(newErrors);
                return;
            }

            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_TICKETING_URL}/message`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                    body: JSON.stringify({
                        ticketId: ticket.id,
                        message: newMessage
                    })
                }
            );
            if (response.ok) {
                const data = await response.json();

                if (!data.success) {
                    setSnackbar({ ...snackbar, open: true, message: data.errorMessage});
                    return;
                }

                ticket.messages.push(data.data.message);

                if (filesToUpload) {
                    await uploadFile(data.data.message.id);
                }

                let newStatus = data.data.newStatus;

                ticket.status = newStatus;
                setActiveStep(newStatus);

                setNewMessage('');
            } else {
                console.log('Message creating failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleSolvedRequest = async () => {
        try {
            const newErrors = validateForm();

            if (Object.keys(newErrors).length > 0) {
                setErrors(newErrors);
                return;
            }

            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_TICKETING_URL}/message`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                    body: JSON.stringify({
                        ticketId: ticket.id,
                        message: newMessage
                    })
                }
            );
            if (response.ok) {
                const data = await response.json();

                if (!data.success) {
                    setSnackbar({ ...snackbar, open: true, message: data.errorMessage});
                    return;
                }

                ticket.messages.push(data.data.message);

                if (filesToUpload) {
                    await uploadFile(data.data.message.id);
                }

                let statusChanged = await UpdateTicketStatus(ticket.id, 3);

                if (statusChanged) {
                    setActiveStep(3);
                } else {
                    console.log('Cant change status to Solved.');
                }

                setNewMessage('');
            } else {
                console.log('Message creating failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleSolveDataUpdate = async (approveUpdating) => {
        try {
            handleCloseSimpleModal();
            let body = {
                ticketId: ticket.id,
                approveUpdating: approveUpdating
            };

            if (approveUpdating && (ticket.subtype === 1 || ticket.subtype === 4 || ticket.subtype === 5)) {
                body.additionalMeta = prepareAdditionalMetaToRequest();
            }

            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_TICKETING_URL}/solve-data-update`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                    body: JSON.stringify(body)
                }
            );
            if (response.ok) {
                const data = await response.json();

                if (!data.success) {
                    setSnackbar({ ...snackbar, open: true, message: data.errorMessage});
                    return;
                }

                await GetClient(ticket.authorId, false); // update client cache

                if (filesToUpload) {
                    await uploadFile(data.data.message.id);
                }

                ticket.messages.push(data.data.message);
                let newStatus = data.data.newStatus;
                ticket.status = newStatus;
                setActiveStep(newStatus);
                setNewMessage('');

                if (approveUpdating && ticket.subtype === 3) {
                    UpdateBanksCache();
                }
            } else {
                const data = await response.json();

                if (!data.success) {
                    setSnackbar({ ...snackbar, open: true, message: data.errorMessage});
                }
                console.log('Ticket approving failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const prepareAdditionalMetaToRequest = () => {
        if (ticket.subtype === 1) {
            additionalMeta.transferDate = null;
            additionalMeta.transferFee = null;
            additionalMeta.transferFeeAssetId = null;
        } else {
            additionalMeta.limitBrokerageAgreementId = null;
            additionalMeta.limitExtensionVolume = null;
            additionalMeta.limitTotalVolume = null;
            additionalMeta.limitReminderVolume = null;
            additionalMeta.limitExtensionNumber = null;
            additionalMeta.limitCreatedDate = null;
            additionalMeta.limitExtensionDate = null;
        }
        return additionalMeta;
    };

    const handleSolveTransferModal = async () => {
        const newErrors = validateTransferModal();

        if (Object.keys(newErrors).length > 0) {
            setAdditionalMetaErrors(newErrors);
            return;
        }

        await handleSolveDataUpdate(true);
        handleCloseTransferModal();
    };

    const handleSolveLimitModal = async () => {
        const newErrors = validateLimitModal();

        if (Object.keys(newErrors).length > 0) {
            setAdditionalMetaErrors(newErrors);
            return;
        }

        await handleSolveDataUpdate(true);
        handleCloseLimitModal();
    };

    const getAuthorName = (authorId) => {
        if (authorId === Number(process.env.REACT_APP_NEWCENT_CONTACT_ID)) {
            return 'Support manager';
        }
        return GetClientViewName(clients.find(e => e.id === authorId));
    };

    const handleFieldChange = (event) => {
        setNewMessage(event.target.value);
    };

    const handleMetaFieldChange = (event) => {
        setAdditionalMeta({
            ...additionalMeta,
            [event.target.name]: event.target.value,
        });
    };

    const handleCloseSimpleModal = () => {
        setShowSimpleModal(false);
    };

    const handleCloseTransferModal = () => {
        setShowTransferModal(false);
        setAdditionalMeta(emptyAdditionalMeta);
    };

    const handleCloseLimitModal = () => {
        setShowLimitModal(false);
        setAdditionalMeta(emptyAdditionalMeta);
    };

    const handleOpenSimpleModal = () => {
        setShowSimpleModal(true);
    };

    const handleOpenTransferModal = () => {
        setShowTransferModal(true);
    };

    const handleOpenLimitModal = () => {
        setShowLimitModal(true);
    };

    const getModalBoxQuestion = () => {
        if (ticket.subtype === 0) {
            return 'This action will change the contact details. Are you sure?';
        }
        if (ticket.subtype === 1) {
            return 'This action will create a operation limit for the contact. If you are sure, please fill in the additional fields.';
        }
        if (ticket.subtype === 2) {
            return 'This action will create a wallet for the contact. Are you sure?';
        }
        if (ticket.subtype === 3) {
            return 'This action will create a bank account for the contact. Are you sure?';
        }
        if (ticket.subtype === 4) {
            return 'This action will create a deposit for the contact. If you are sure, please fill in the additional fields.';
        }
        if (ticket.subtype === 5) {
            return 'This action will create a withdrawal for the contact. If you are sure, please fill in the additional fields.';
        }
        return 'If you see this text, it means something went wrong. Please report this to the administrator.';
    };

    const handleApproveButton = () => {
      if (ticket.subtype === 0 || ticket.subtype === 2 || ticket.subtype === 3) {
          handleOpenSimpleModal();
      }  else if (ticket.subtype === 4 || ticket.subtype === 5) {
          handleOpenTransferModal();
      }  else if (ticket.subtype === 1) {
          handleOpenLimitModal();
      } else {
          handleSolveDataUpdate(true);
      }
    };

    const GetAgreementsMenuItems = () => {
        let items = [];
        if (agreements) {
            agreements.forEach((elem) => {
                items.push(
                    <MenuItem key={elem.id} value={elem.id}>
                        {GetBrokerageAgreementTitle(elem)}
                    </MenuItem>
                );
            });
        }
        return items;
    };

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}>
                <StyledAlert onClose={handleCloseSnackbar} severity="error" sx={{ width: '100%' }}>
                    {snackbar.message}
                </StyledAlert>
            </Snackbar>
            <StyledStepper activeStep={activeStep} alternativeLabel>
                {Object.values(GetEnumValues('ticketStatus')).map((label, index) => (
                    <Step key={index}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                ))}
            </StyledStepper>
            <StyledTable>
                <TableBody>
                    {ticket?.messages?.map((message) => (
                        <TableRow key={message.id}>
                            <StyledTableCell>
                                <Typography variant="h6" gutterBottom sx={{ color: Black }}>
                                    {getAuthorName(message.authorId)} {moment(message.date).fromNow()}
                                </Typography>
                                <Typography sx={{ mb: 1.5, whiteSpace: 'pre-line' }} color="text.secondary">
                                    {message.message}
                                </Typography>
                                {GetMessageFilesComponent(ticketId, message.id, files)}
                            </StyledTableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </StyledTable>
            {ticket && ticket?.status !== 4 && (
                <>
                    <TextField
                        name="newMessage"
                        label="New Message"
                        value={newMessage}
                        onChange={handleFieldChange}
                        fullWidth
                        multiline
                        rows={2}
                        required
                        error={!!errors.newMessage}
                        helperText={errors.newMessage}
                        style={{ padding: '5px' }}
                    />
                    <Grid container alignItems="center" style={{ padding: '5px'  }}>
                        <Grid item>
                            <input id='filePicker' multiple={true} type="file" onChange={saveFile} style={{ display: 'none' }}/>
                            <label htmlFor='filePicker'>
                                <Grid container alignItems="center">
                                    <StyledButtonNoColor variant="contained" component="span">
                                        <AttachFileIcon/>
                                    </StyledButtonNoColor>
                                    <Typography variant="body1" style={{ marginLeft: '8px' }}>
                                        {filesToUpload
                                            ? filesToUpload.length > 1 ? `Picked ${filesToUpload.length} files` :  filesToUpload[0].name
                                            : ''}
                                    </Typography>
                                </Grid>
                            </label>
                        </Grid>
                        <Grid item>
                            {filesToUpload && filesToUpload.length > 0 && (
                                <StyledButtonNoColor variant="contained" component="span" onClick={clearFiles} style={{ marginLeft: '8px' }}>
                                    <ClearIcon/>
                                </StyledButtonNoColor>
                            )}
                        </Grid>
                    </Grid>
                </>)}
            <StyledButtonContainer container>
                <Grid>
                    <StyledButtonOrange variant="contained" onClick={handleBack}>
                        Back
                    </StyledButtonOrange>
                </Grid>
                <Grid>
                    <StyledButtonOrange variant="contained" disabled={!ticket || ticket?.status === 4} color="primary" onClick={handleSendRequest}>
                        Reply
                    </StyledButtonOrange>
                </Grid>
                {ticket && ticket.type !== 9 && (
                    <Grid>
                        <StyledButtonBlack variant="contained" disabled={!ticket || ticket?.status === 4} color="primary" onClick={handleSolvedRequest}>
                            Solve
                        </StyledButtonBlack>
                    </Grid>
                )}
                {ticket && ticket.type === 9 && (
                    <>
                        <Grid>
                            <StyledButtonBlack variant="contained"
                                               disabled={!ticket || ticket?.status === 4} color="primary"
                                               onClick={handleApproveButton}>
                                Approve
                            </StyledButtonBlack>
                        </Grid>
                        <Grid>
                            <StyledButtonBlack variant="contained"
                                               disabled={!ticket || ticket?.status === 4} color="primary"
                                               onClick={() => handleSolveDataUpdate(false)}>
                                Reject
                            </StyledButtonBlack>
                        </Grid>
                    </>
                )}
            </StyledButtonContainer>
            {showSimpleModal && (<Modal open={showSimpleModal} onClose={handleCloseSimpleModal}>
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                }}>
                    <Typography variant="h6" component="h2">
                        {getModalBoxQuestion()}
                    </Typography>
                    <Grid container spacing={2} marginTop={3}>
                        <Grid item xs={12} md={6}>
                            <StyledButtonOrange onClick={handleCloseSimpleModal}>
                                Cancel
                            </StyledButtonOrange>
                        </Grid>
                        <Grid item xs={12} md={6} sx={{ textAlign: 'right' }}>
                            <StyledButtonBlack onClick={() => handleSolveDataUpdate(true)}>
                                Approve
                            </StyledButtonBlack>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>)}
            {showTransferModal && (<Modal open={showTransferModal} onClose={handleCloseTransferModal}>
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                }}>
                    <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
                        {getModalBoxQuestion()}
                    </Typography>
                    <DatePicker
                        timezone="UTC"
                        name="transferDate"
                        label="Transfer Date"
                        value={dayjs(additionalMeta.transferDate)}
                        onChange={(date) =>  {
                            let event = {
                                'target': {
                                    'name': 'transferDate',
                                    'value': date.toJSON()
                                }
                            };
                            handleMetaFieldChange(event);
                        }
                        }
                        fullWidth
                        size='small'
                        error={!!additionalMetaErrors.transferDate}
                        helperText={additionalMetaErrors.transferDate}
                        sx={{ mb: 2 }}
                    />
                    <TextField
                        name="transferFee"
                        label="Transfer Fee"
                        value={additionalMeta.transferFee}
                        onChange={handleMetaFieldChange}
                        fullWidth
                        required
                        error={!!additionalMetaErrors.transferFee}
                        helperText={additionalMetaErrors.transferFee}
                        sx={{ mb: 2 }}
                    />
                    <TextField
                        name="transferFeeAssetId"
                        label="Transfer Fee Asset"
                        select
                        value={additionalMeta.transferFeeAssetId}
                        onChange={handleMetaFieldChange}
                        fullWidth
                        required
                        error={!!additionalMetaErrors.transferFeeAssetId}
                        helperText={additionalMetaErrors.transferFeeAssetId}
                        sx={{ mb: 2 }}
                    >
                        {GetLookupMenuItems('asset')}
                    </TextField>
                    <Grid container spacing={2} marginTop={3}>
                        <Grid item xs={12} md={6}>
                            <StyledButtonOrange onClick={handleCloseTransferModal}>
                                Cancel
                            </StyledButtonOrange>
                        </Grid>
                        <Grid item xs={12} md={6} sx={{ textAlign: 'right' }}>
                            <StyledButtonBlack onClick={handleSolveTransferModal}>
                                Approve
                            </StyledButtonBlack>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>)}
            {showLimitModal && (<Modal open={showLimitModal} onClose={handleCloseLimitModal}>
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                }}>
                    <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
                        {getModalBoxQuestion()}
                    </Typography>
                    <TextField
                        name="limitBrokerageAgreementId"
                        label="Brokerage Agreement"
                        select
                        value={additionalMeta.limitBrokerageAgreementId}
                        onChange={handleMetaFieldChange}
                        fullWidth
                        required
                        error={!!additionalMetaErrors.limitBrokerageAgreementId}
                        helperText={additionalMetaErrors.limitBrokerageAgreementId}
                        sx={{ mb: 2 }}
                    >
                        {GetAgreementsMenuItems()}
                    </TextField>
                    <DatePicker
                        timezone="UTC"
                        name="limitCreatedDate"
                        label="Created Date"
                        value={dayjs(additionalMeta.limitCreatedDate)}
                        onChange={(date) =>  {
                            let event = {
                                'target': {
                                    'name': 'limitCreatedDate',
                                    'value': date.toJSON()
                                }
                            };
                            handleMetaFieldChange(event);
                        }
                        }
                        fullWidth
                        size='small'
                        slotProps={{
                            textField: {
                                required: true,
                            },
                        }}
                        error={!!additionalMetaErrors.limitCreatedDate}
                        helperText={additionalMetaErrors.limitCreatedDate}
                        sx={{ mb: 2 }}
                    />
                    <DatePicker
                        timezone="UTC"
                        name="limitExtensionDate"
                        label="Extension Date"
                        value={dayjs(additionalMeta.limitExtensionDate)}
                        onChange={(date) =>  {
                            let event = {
                                'target': {
                                    'name': 'limitExtensionDate',
                                    'value': date.toJSON()
                                }
                            };
                            handleMetaFieldChange(event);
                        }
                        }
                        fullWidth
                        size='small'
                        slotProps={{
                            textField: {
                                required: true,
                            },
                        }}
                        error={!!additionalMetaErrors.limitExtensionDate}
                        helperText={additionalMetaErrors.limitExtensionDate}
                        sx={{ mb: 2 }}
                    />
                    <TextField
                        name="limitExtensionNumber"
                        label="Extension Number"
                        value={additionalMeta.limitExtensionNumber}
                        onChange={handleMetaFieldChange}
                        fullWidth
                        required
                        error={!!additionalMetaErrors.limitExtensionNumber}
                        helperText={additionalMetaErrors.limitExtensionNumber}
                        sx={{ mb: 2 }}
                    />
                    <TextField
                        name="limitExtensionVolume"
                        label="Extension Volume"
                        value={additionalMeta.limitExtensionVolume}
                        onChange={handleMetaFieldChange}
                        fullWidth
                        required
                        error={!!additionalMetaErrors.limitExtensionVolume}
                        helperText={additionalMetaErrors.limitExtensionVolume}
                        sx={{ mb: 2 }}
                    />
                    <TextField
                        name="limitTotalVolume"
                        label="Total Volume"
                        value={additionalMeta.limitTotalVolume}
                        onChange={handleMetaFieldChange}
                        fullWidth
                        required
                        error={!!additionalMetaErrors.limitTotalVolume}
                        helperText={additionalMetaErrors.limitTotalVolume}
                        sx={{ mb: 2 }}
                    />
                    <TextField
                        name="limitReminderVolume"
                        label="Reminder Volume"
                        value={additionalMeta.limitReminderVolume}
                        onChange={handleMetaFieldChange}
                        fullWidth
                        required
                        error={!!additionalMetaErrors.limitReminderVolume}
                        helperText={additionalMetaErrors.limitReminderVolume}
                        sx={{ mb: 2 }}
                    />
                    <Grid container spacing={2} marginTop={3}>
                        <Grid item xs={12} md={6}>
                            <StyledButtonOrange onClick={handleCloseLimitModal}>
                                Cancel
                            </StyledButtonOrange>
                        </Grid>
                        <Grid item xs={12} md={6} sx={{ textAlign: 'right' }}>
                            <StyledButtonBlack onClick={handleSolveLimitModal}>
                                Approve
                            </StyledButtonBlack>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>)}
        </Container>
    );
};

export default ManagerTicketPage;
